import { cn } from "@/utils/cn";

import { Image } from "./Image";

interface LogoProps {
  className?: string;
  variant?: "light" | "dark";
}

export const Logo = ({ className, variant = "light" }: LogoProps) => (
  <div className={cn("flex items-center gap-2 no-underline", className)}>
    <Image src={`/images/logo-${variant}.webp`} alt="Dualio" width={88} height={22} />
  </div>
);
